import { useRouterState } from "@tanstack/react-router";
import { percent, px } from "csx";
import { Vertical } from "gls";
import { FC, Fragment, ReactNode } from "react";
import { style } from "typestyle";
import {
  Accordion,
  AccordionContent,
  AccordionHeader,
} from "../accordion/Accordion";
import { SidebarRoute } from "./routes";

export const PlanMenu: FC<{
  isCollapsed: boolean;
  route: SidebarRoute;
  isVisible: (route: SidebarRoute) => boolean;
  renderItem: (route: SidebarRoute) => ReactNode;
}> = ({ isCollapsed, route, isVisible, renderItem }) => {
  const {
    location: { pathname },
  } = useRouterState();

  if (!isVisible(route)) return null;
  if (isCollapsed) return <>{renderItem(route)}</>;

  const getInitialOpenIds = (item: SidebarRoute): string[] => {
    const childOpenIds = item.children?.flatMap(getInitialOpenIds) ?? [];

    return pathname === item.path || childOpenIds.length
      ? [item.path, ...childOpenIds]
      : [];
  };

  const renderRoute = (item: SidebarRoute): ReactNode => {
    const children = item.children?.filter(isVisible) ?? [];

    if (!children.length) return renderItem(item);

    return (
      <Fragment key={item.path}>
        <AccordionHeader id={item.path}>{renderItem(item)}</AccordionHeader>
        <AccordionContent id={item.path}>
          <Vertical
            width={percent(100)}
            padding={[0, 0, 0, px(20)]}
            className={style({ boxSizing: "border-box" })}
          >
            {children.map(renderRoute)}
          </Vertical>
        </AccordionContent>
      </Fragment>
    );
  };

  return (
    <Accordion allowsMultiple initialOpenIds={getInitialOpenIds(route)}>
      {renderRoute(route)}
    </Accordion>
  );
};
